import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2c09fd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "chat-header"
}
const _hoisted_2 = { class: "chat-messages" }
const _hoisted_3 = ["onMouseover"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "message-buttons"
}
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = {
  key: 1,
  class: "tags"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 2,
  class: "loading-message"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-indicator" }, null, -1))
const _hoisted_11 = {
  key: 1,
  class: "chat-input"
}
const _hoisted_12 = { class: "doc-type-picker-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Select Document Type", -1))
const _hoisted_14 = { class: "doc-type-list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chat-content", { 'modal': _ctx.depth > 0 }]),
    style: _normalizeStyle({ zIndex: 1000 + _ctx.depth })
  }, [
    (_ctx.depth > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h3", null, "Trace Information (Level " + _toDisplayString(_ctx.depth) + ")", 1),
          _createElementVNode("button", {
            class: "close-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, "×")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "messages-container",
      ref: "messagesContainer",
      onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
    }, [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
          return (_openBlock(), _createElementBlock("li", {
            key: message.id
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["message", { 'user-message': message.msgType === 'PlayerInput', 'bot-message': message.msgType !== 'PlayerInput' }]),
              onMouseover: ($event: any) => (_ctx.startTooltipTimer(message, $event)),
              onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelTooltipTimer && _ctx.cancelTooltipTimer(...args)))
            }, [
              _createElementVNode("div", {
                class: "message-content",
                innerHTML: _ctx.renderMarkdown(message.text)
              }, null, 8, _hoisted_4),
              (message.buttons && message.buttons.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.buttons, (button) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: button.id,
                        disabled: button.disabled,
                        class: _normalizeClass(["message-action-button", { 'disabled': button.disabled, 'highlight': button.highlight }]),
                        style: _normalizeStyle({
                                    backgroundColor: button.disabled ? '#cccccc' : (button.backgroundColor || '#007bff'),
                                    color: button.disabled ? '#666666' : (button.textColor || 'white'),
                                    borderColor: button.borderColor || 'transparent'
                                }),
                        onClick: ($event: any) => (_ctx.handleButtonClick(button, message))
                      }, _toDisplayString(button.text), 15, _hoisted_6))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (message.tags && message.tags.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.tags, (tag) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "tag",
                        key: tag
                      }, _toDisplayString(tag), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (message.traceInfo && message.traceInfo.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "trace-info-icon",
                    onClick: _withModifiers(($event: any) => (_ctx.$emit('openTraceInfo', message, _ctx.depth)), ["stop"])
                  }, " ℹ️ ", 8, _hoisted_8))
                : _createCommentVNode("", true)
            ], 42, _hoisted_3)
          ]))
        }), 128))
      ]),
      (_ctx.showTriggerSystem2Button)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('triggerSystem2'))),
            class: "trigger-system-2-button"
          }, " Trigger System 2 "))
        : _createCommentVNode("", true),
      (_ctx.showScrollButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.scrollToBottom && _ctx.scrollToBottom(...args))),
            class: "scroll-to-bottom"
          }, " ⤓ "))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(" AI is thinking... ")
          ]))
        : _createCommentVNode("", true)
    ], 544),
    (_ctx.depth === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newMessage) = $event)),
            placeholder: "Type your message...",
            onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]), ["enter"])),
            class: "message-input"
          }, null, 544), [
            [_vModelText, _ctx.newMessage]
          ]),
          _createElementVNode("button", {
            class: "send-button",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
          }, "Send"),
          (_ctx.fileUploadButton.visible)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                id: "file_upload_button",
                class: _normalizeClass(["attach-button", { 'highlight': _ctx.fileUploadButton.highlight }]),
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showDocTypePicker && _ctx.showDocTypePicker(...args)))
              }, _toDisplayString(_ctx.fileUploadButton.caption), 3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDocTypePickerModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "doc-type-picker-modal",
          onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDocTypePicker && _ctx.closeDocTypePicker(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableDocTypes, (docType) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: docType,
                  class: "doc-type-button",
                  onClick: ($event: any) => (_ctx.selectDocType(docType))
                }, _toDisplayString(docType), 9, _hoisted_15))
              }), 128))
            ]),
            _createElementVNode("button", {
              class: "close-picker",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeDocTypePicker && _ctx.closeDocTypePicker(...args)))
            }, "Cancel")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.tooltipVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "tooltip",
          style: _normalizeStyle(_ctx.tooltipStyle)
        }, [
          _createElementVNode("div", { innerHTML: _ctx.tooltipContent }, null, 8, _hoisted_16)
        ], 4))
      : _createCommentVNode("", true)
  ], 6))
}